import { Link } from "react-router-dom";
import { Brain, AlertTriangle, ClipboardCheck, ArrowRight } from "lucide-react";
import { AdminLayout } from "@/components/AdminLayout";

const REQUISITOS = [
  {
    tramo: "Hasta 15 trabajadores",
    puntos: [
      "Tener una política por escrito de prevención de riesgos psicosociales.",
      "Difundirla entre el personal y atender los casos que se detecten.",
      "Identificar a las personas trabajadoras expuestas a acontecimientos traumáticos severos y tomar las medidas de prevención correspondientes.",
    ],
  },
  {
    tramo: "De 16 a 50 trabajadores",
    puntos: [
      "Todo lo anterior.",
      "Aplicar el cuestionario de identificación y análisis de los factores de riesgo psicosocial (Guía de Referencia II). El cuestionario de entorno organizacional NO aplica en este tramo, solo a partir de 51 trabajadores.",
      "Contar con prácticas para prevenir y atender la violencia laboral, y para promover un entorno organizacional favorable.",
    ],
  },
  {
    tramo: "Más de 50 trabajadores",
    puntos: [
      "Todo lo anterior.",
      "Aplicar el cuestionario de identificación y análisis de factores de riesgo psicosocial (Guía de Referencia II).",
      "Aplicar además el cuestionario de evaluación del entorno organizacional (Guía de Referencia III); se permite aplicarlo a una muestra representativa.",
      "Conservar los registros y las medidas correctivas por si la STPS los solicita.",
    ],
  },
];

export default function Nom035() {
  return (
    <AdminLayout>
      <div className="max-w-2xl">
        <h1 className="font-heading text-3xl font-bold text-charcoal tracking-tight flex items-center gap-3">
          <Brain className="w-7 h-7 text-petroleum" strokeWidth={1.5} /> Cumplimiento NOM-035
        </h1>
        <p className="text-charcoal/60 mt-1 mb-6">
          Lo que necesitas saber sobre esta norma, explicado sin tecnicismos.
        </p>

        <div className="bg-card border border-petroleum/10 rounded-xl p-5 mb-5">
          <h2 className="font-heading text-lg font-semibold text-charcoal mb-2">¿Qué es?</h2>
          <p className="text-sm text-charcoal/70 leading-relaxed">
            La NOM-035 es una norma oficial mexicana que obliga a las empresas a identificar y prevenir
            los factores de riesgo psicosocial en el trabajo: estrés, jornadas excesivas, violencia
            laboral, malos liderazgos y falta de balance entre el trabajo y la vida personal. Aplica a
            todas las empresas del país, sin importar cuántas personas empleen.
          </p>
        </div>

        <div className="bg-card border border-petroleum/10 rounded-xl p-5 mb-5">
          <h2 className="font-heading text-lg font-semibold text-charcoal mb-2 flex items-center gap-2">
            <AlertTriangle className="w-5 h-5 text-amber-600" strokeWidth={1.5} /> ¿Por qué debes cumplirla?
          </h2>
          <p className="text-sm text-charcoal/70 leading-relaxed">
            Es obligatoria desde 2019 y la revisa la Secretaría del Trabajo y Previsión Social (STPS).
            No cumplirla puede resultar en multas y en observaciones durante una inspección laboral, y
            deja a la empresa expuesta si un trabajador presenta una demanda relacionada con el ambiente
            de trabajo. Más allá de la norma, prevenir estos riesgos reduce el ausentismo y la rotación
            de personal.
          </p>
        </div>

        <div className="bg-card border border-petroleum/10 rounded-xl p-5 mb-5">
          <h2 className="font-heading text-lg font-semibold text-charcoal mb-3 flex items-center gap-2">
            <ClipboardCheck className="w-5 h-5 text-petroleum" strokeWidth={1.5} /> ¿Qué te pide, según tu número de empleados?
          </h2>
          <div className="space-y-4">
            {REQUISITOS.map((r) => (
              <div key={r.tramo}>
                <p className="text-sm font-semibold text-charcoal mb-1">{r.tramo}</p>
                <ul className="text-sm text-charcoal/70 space-y-1 list-disc list-inside">
                  {r.puntos.map((p) => (
                    <li key={p}>{p}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-petroleum/5 border border-petroleum/20 rounded-xl p-5">
          <p className="text-sm text-charcoal/80 leading-relaxed mb-3">
            ¿Prefieres que un profesional de RH se encargue de aplicar los cuestionarios, armar tus
            políticas y dejarte listos los registros que pide la STPS? Ese acompañamiento se contrata
            por separado, con un costo adicional, y lo coordinamos contigo antes de empezar.
          </p>
          <Link
            to="/admin/consultoria"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-petroleum hover:underline"
          >
            Solicitar este servicio <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
          </Link>
        </div>
      </div>
    </AdminLayout>
  );
}
